// extracted by mini-css-extract-plugin
export default {"partner__section":"Partners_partner__section__xvjmy","partner__section__title":"Partners_partner__section__title__ScsZo"};